import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import React from 'react';
import {
  Wrapper,
  Container,
  Box,
  IconMapWrapper,
  Title,
  Text,
  Content
} from './styled';

export const FindUs: React.FC = () => (
  <Wrapper>
    <Container>
      <Box href="https://clasificados.pe/agencias" target="_blank">
        <Content>
          <IconMapWrapper>
            <Icon data-name="icon-map" width="43" height="43" fill={COLORS.BLACK} />
          </IconMapWrapper>
          <Title>Encuéntranos</Title>
          <Text>Encuentra la agencia más cercana en dónde publicar tu aviso impreso</Text>
        </Content>
      </Box>
    </Container>
  </Wrapper>
);